export default "/images/9dda85d3e84165dc3537dc65a3796f2f.png";